import { DataGridPro, DataGridProProps } from '@mui/x-data-grid-pro'

import { styled } from '../../theme'
import { MsdkStyledComponent } from '../../utils'

export const DataTree: MsdkStyledComponent<DataGridProProps> = styled(DataGridPro)`
  .MuiDataGrid-cell:focus {
    outline: none;
  }
  .MuiDataGrid-cell:focus-within {
    outline: none;
  }
`
